import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CustomerReviewComponent } from './customer-review.component';
import { CustomerReviewResolve } from './customer-review.resolve';
import { AuthGuard } from '../../../core/services/authGuard';

const routes: Routes = [
  {
    path: 'review/:charterId',
    component: CustomerReviewComponent,
    resolve: {
      charterData: CustomerReviewResolve,
    },
    data: {
      AuthGuard,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CustomerReviewRoutingModule {}
